import styled from 'styled-components';
import { media } from './StyledCalendarBase';

// Estilos específicos para la vista Month
export const MonthViewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
`;

export const MonthHeaderRow = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 1px;
    background: hsl(220, 13%, 91%);
    flex-shrink: 0;

    ${media.mobile} {
        display: none;
    }
`;

export const MonthHeaderCell = styled.div`
    padding: 16px;
    text-align: center;
    color: hsl(0, 0%, 30%);
    font-size: 14px;
    font-weight: 600;
    background: #FFFFFF;

    ${media.tablet} {
        padding: 12px;
        font-size: 13px;
    }
`;

export const MonthGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-auto-rows: minmax(0, 1fr);
    flex: 1 1 auto;
    min-height: 0;
    height: 100%;

    /* Las líneas de la grilla salen de este gap + fondo */
    gap: 1px;
    background: hsl(220, 13%, 91%);

    /* Línea entre encabezado de días y celdas */
    border-top: 1px solid hsl(220, 13%, 91%);

    ${media.mobile} {
        display: flex;
        flex-direction: column;
        gap: 8px;
        height: auto;
        background: transparent;
        border-top: none;
    }
`;

export const MonthCell = styled.div`
    height: 100%;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    /* Cada celda tapa el fondo gris, y el gap queda como línea */
    background: #FFFFFF;
    transition: background 0.2s ease;

    &:hover {
        background: ${props => props.isPlaceholder ? '#FFFFFF' : 'hsl(210, 40%, 96%)'};
    }

    ${media.mobile} {
        height: auto;
        min-height: 70px;
        padding: 12px;
        border: 1px solid hsl(220, 13%, 91%);
        border-radius: 8px;
        background: #FFFFFF;

        &:hover {
            background: ${props => props.isPlaceholder ? '#FFFFFF' : 'hsl(210, 40%, 96%)'};
        }
    }
`;

export const MonthDay = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 600;
    font-size: 18px;
    color: ${props => props.active ? '#FFFFFF' : 'hsl(0, 0%, 25%)'};
    background: ${props => props.active ? 'hsl(24, 85%, 60%)' : 'transparent'};
    transition: background 0.2s ease, color 0.2s ease;
    z-index: 1;

    &:hover {
        background: ${props => props.active ? 'hsl(24, 85%, 60%)' : 'hsl(210, 40%, 95%)'};
    }

    ${media.tablet} {
        width: 42px;
        height: 42px;
        font-size: 16px;
    }

    ${media.mobile} {
        width: 36px;
        height: 36px;
        font-size: 14px;
    }
`;

export const MonthDayWithToday = styled(MonthDay)`
    color: ${props => props.isToday ? '#FFFFFF' : 'hsl(0, 0%, 25%)'};
    font-size: 14px;
    font-weight: 600;
`;

// Badge para resumir tipos de evento dentro de cada celda del mes.
// Cada badge aparece en una esquina distinta y muestra la cantidad.
// Los colores coinciden con los tipos principales del calendario.
export const MonthNotificationBadge = styled.div`
    position: absolute;
    min-width: 22px;
    height: 22px;
    padding: 0 7px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 800;
    line-height: 1;
    z-index: 2;
    box-sizing: border-box;
    color: ${props => props.variant === 'colegio' ? '#1F2937' : '#FFFFFF'};
    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.85);

    /* Posiciones por esquina */
    ${props => props.position === 'topLeft' && `
        top: 8px;
        left: 8px;
    `}

    ${props => props.position === 'topRight' && `
        top: 8px;
        right: 8px;
    `}

    ${props => props.position === 'bottomLeft' && `
        bottom: 8px;
        left: 8px;
    `}

    ${props => props.position === 'bottomRight' && `
        bottom: 8px;
        right: 8px;
    `}

    /* Colores por tipo de evento */
    ${props => props.variant === 'ok' && `
        background-color: #23AAAF;
    `}

    ${props => props.variant === 'padres' && `
        background-color: #D76970;
    `}

    ${props => props.variant === 'colegio' && `
        background-color: #EFC340;
    `}

    ${props => props.variant === 'profesionales' && `
        background-color: #FC8906;
    `}

    ${props => !props.variant && `
        background-color: #646464;
    `}

    ${media.tablet} {
        min-width: 20px;
        height: 20px;
        font-size: 10px;
        padding: 0 6px;
    }

    ${media.mobile} {
        min-width: 19px;
        height: 19px;
        font-size: 9px;
        padding: 0 5px;
    }
`;

/* Estos dos podés dejarlos si todavía los usa alguna otra parte.
   Si no los usa nadie, después los borramos tranquilos. */
export const MonthAppointmentDot = styled.div`
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: translateX(-50%);
    width: 18px;
    height: 18px;
    background-color: #23AAAF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const MonthAppointmentCount = styled.div`
    font-size: 9px;
    font-weight: 700;
    color: #FFFFFF;
`;